import { WarningIcon } from './icons';

interface DayLimitModalProps {
  open: boolean;
  onClose: () => void;
}

const DayLimitModal = ({ open, onClose }: DayLimitModalProps) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
      }}
    >
      <div style={{ background: '#fff', borderRadius: '1rem', padding: '1.5rem', maxWidth: 380, width: '90%', textAlign: 'center', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
          <WarningIcon />
        </div>
        <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#374151', marginBottom: '0.75rem' }}>
          Demasiadas sesiones este día
        </h3>
        <p style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '1.5rem', lineHeight: 1.5 }}>
          Ya tenés 10 horas o más de sesiones agendadas para este día. Te recomendamos elegir otro día para cuidar tu bienestar.
        </p>
        <button
          type="button"
          onClick={onClose}
          style={{ background: '#6D57BC', color: '#fff', border: 'none', borderRadius: 9999, padding: '0.625rem 1.5rem', fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer' }}
        >
          Entendido
        </button>
      </div>
    </div>
  );
};

export default DayLimitModal;
